// @mui
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  Stack,
  Table,
  TableContainer,
  Typography
} from '@mui/material';
// components
import Scrollbar from '@src/components/scrollbar';
// mock
import styled from '@emotion/styled';
import DataTableRow from '@src/components/data-table/data-row';
import Iconify from '@src/components/iconify';
import { TABLE_HEAD_LASTWEEK_DRAW_RESULT } from '@src/utils/mockdata/table-headers';
import _ from 'lodash';
import moment from 'moment';
import { useDrawResultContext } from '../provider';
import TableHeader from './table-header';
import TableRowItem from './table-row';

function ViewWinners() {
  const { viewWinners, setViewWinners } = useDrawResultContext();

  return (
    <BootstrapDialog
      open={!_.isEmpty(viewWinners)}
      maxWidth="md"
      onClose={() => setViewWinners(null)} 
      >
      <DialogContent>
        <ButtonClose onClick={() => setViewWinners(null)}>
          <Iconify  icon={'mdi:close'} width={25} />
        </ButtonClose>
        <Body />
      </DialogContent>
    </BootstrapDialog>
  );
}

const Body = () => {
  const { state, viewWinners, handleRequestSort } = useDrawResultContext();

  return (
    <Container disableGutters sx={{ mt: 3 }}>
      <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"auto"}>
        <Typography display={"inline"} color={"#333B69"} fontSize={19} fontWeight={700}>
            Description: <Typography component={"span"} color="#718EBF" fontSize={19} 
            fontWeight={700}>{viewWinners?.raffle?.description}</Typography> 
        </Typography>
      </Stack>
      <Stack mt={2} direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"auto"}>
        <Typography color="#333B69" fontSize={19} fontWeight={700}>
          Draw Number: <Typography component={"span"} color="#718EBF" fontSize={19} 
          fontWeight={700}>{viewWinners?.raffle?.code}</Typography> 
        </Typography>
        <Typography display={"inline"} color={"#333B69"} fontSize={19} fontWeight={700}>
            Draw Date: <Typography component={"span"} color="#718EBF" fontSize={19} 
            fontWeight={700}>{moment(viewWinners?.raffle?.drawAt).format("MM/DD/YYYY")}</Typography> 
        </Typography>
      </Stack>
      <Stack sx={{p: 2}}>
        <Scrollbar>
          <TableContainer>
            <Table>
              <TableHeader
                disableButton
                order={state.order}
                orderBy={state.orderBy}
                headLabel={TABLE_HEAD_LASTWEEK_DRAW_RESULT}
                onRequestSort={handleRequestSort}
              />
              <DataTableRow
                colSpan={7}
                headers={TABLE_HEAD_LASTWEEK_DRAW_RESULT}
                data={viewWinners?.winners ?? []}
                renderItem={({ item, index }: any) => {
                  return <TableRowItem 
                    key={`${index}`} {...item} 
                    // onOpenEdit={() => openEdit(item)} 
                    />
                }} />
            </Table>
          </TableContainer>
        </Scrollbar>
      </Stack>
    </Container>
  );
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "100%",
    // height: 328,
    borderRadius: 20,
    margin: 0,
    padding: 0,
  },
}));

export const ButtonClose = styled(Button)(({ theme }) => ({
  width: 30, 
  height: 30,
  color: "#7D7D7D", 
  backgroundColor: "white", 
  position: "absolute",
  top: 20,
  right: 10,
}));

export default ViewWinners;
